import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TranslateModule } from '@ngx-translate/core';

import { JobMapComponent } from './job-map.component';
import { JobMapRoutingModule } from './job-map-routing.module';

@NgModule({
  declarations: [JobMapComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSliderModule,
    NgxMatSelectSearchModule,
    TranslateModule,
    JobMapRoutingModule,
  ],
})
export class JobMapModule {}
